module.exports = __webpack_public_path__ + "f83d47d1882684e2300c83b796921c43.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/student_mob_gray.gif
 ** module id = 460
 ** module chunks = 0
 **/